import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5780742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "other-solutions" }
const _hoisted_2 = { class: "solutions container" }
const _hoisted_3 = { class: "solution" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"title-content\" data-v-d5780742><div class=\"top-line\" data-v-d5780742><h1 class=\"title\" data-v-d5780742>Full <span class=\"color\" data-v-d5780742>Retail</span> Solution</h1><p class=\"title-text\" data-v-d5780742> You cannot replace the thrill of the retail shop betting rush! </p></div></div><hr data-v-d5780742>", 2)
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dark" }, " Expand your current betting shop with new games, better designs and a faster processing to further engage and bring even more customers. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " A massive range of betting products to offer your players will upgrade your current operation and give a powerful boost to your marketing and branding efforts. ", -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "solution" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"title-content\" data-v-d5780742><div class=\"top-line\" data-v-d5780742><h1 class=\"title\" data-v-d5780742>Full <span class=\"color\" data-v-d5780742>Online</span> Solution</h1><p class=\"title-text\" data-v-d5780742> Unlimited reach any time, any day, whole year round! </p></div></div><hr data-v-d5780742>", 2)
const _hoisted_15 = { class: "content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dark" }, " Bring your betting shop to the new digital age as the advancement of new technology, internet and smartphones has made it mandatory to offer players an online access. ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Supplement your current retail operations with added online presence or run a fully digital shop as a separate business unit. The platform has been specifically engineered to launch online platform within 1 day with modular product offerings. ", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quote" }, [
  /*#__PURE__*/_createElementVNode("span", null, " \"Aardvark Technologies system architecture allows it to adapt fast, stay lean and evolve together with the ever growing markets and constantly changing needs.\" "),
  /*#__PURE__*/_createElementVNode("span", { class: "author" }, " - Simas Denisovas, CEO ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FAIcon = _resolveComponent("FAIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retailPoints, (point) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: point.title
                }, [
                  _createElementVNode("span", {
                    class: "select",
                    onClick: ($event: any) => (_ctx.toggleExpanded(point.title))
                  }, [
                    _createTextVNode(_toDisplayString(point.title) + " ", 1),
                    _createVNode(_component_FAIcon, {
                      icon: "chevron-down",
                      class: _normalizeClass(["icon", { expanded: point.title === _ctx.expanded }])
                    }, null, 8, ["class"])
                  ], 8, _hoisted_10),
                  _createVNode(_Transition, { name: "appear" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("span", { class: "description" }, _toDisplayString(point.description), 513), [
                        [_vShow, _ctx.expanded === point.title]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlinePoints, (point) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: point.title
                }, [
                  _createElementVNode("span", {
                    class: "select",
                    onClick: ($event: any) => (_ctx.toggleExpanded(point.title))
                  }, [
                    _createTextVNode(_toDisplayString(point.title) + " ", 1),
                    _createVNode(_component_FAIcon, {
                      icon: "chevron-down",
                      class: _normalizeClass(["icon", { expanded: point.title === _ctx.expanded }])
                    }, null, 8, ["class"])
                  ], 8, _hoisted_18),
                  _createVNode(_Transition, { name: "appear" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("span", { class: "description" }, _toDisplayString(point.description), 513), [
                        [_vShow, _ctx.expanded === point.title]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ]),
            _hoisted_19
          ])
        ])
      ])
    ])
  ]))
}